export interface ITimestampMetadata {
  updated_at: string;
  created_at: string;
}

export function instanceOfITimestampMetadata(object?: any): object is ITimestampMetadata {
  return !!object && "updated_at" in object && typeof object.updated_at === "string" && "created_at" in object && typeof object.created_at === "string";
}
